//types
import ActionType from 'store/actionTypes';

const resetList = (): any => async (dispatch: any) => {
  dispatch({type: ActionType.GET_EVENTS_SUCCESS, data: {list: []}});
};

export default resetList;
